<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <small class="fw-bolder"><span>تدوین ارکان جهت ساز</span> / <span>نمای کلی سازمان  </span></small>
          <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
        </div>
        <hr class="mb-3">
        <div class="d-flex flex-nowrap flex-column">
          <div class="d-flex">
            <div class="card col-6 shadow border-radius-20 d-flex flex-column align-items-start p-2">
              <p class="fw-bold">  چه چالش های اساسی پیش روی سازمان قرار دارد؟
              </p>
              <hr>
              <textarea v-model="text_first" name="" class="form-control" :class="{'is-invalid' : text_first_error}" id=""
                        cols="30" rows="10"></textarea>
            </div>
            <div class="card col-6 mx-2 shadow border-radius-20 d-flex flex-column align-items-start p-2">
              <p class="fw-bold">   اگر این چالش ها را حل کنیم
                آینده به چه صورتی است؟</p>
              <hr>
              <textarea v-model="text_second" name="" class="form-control" :class="{'is-invalid' : text_first_error}" id=""
                        cols="30" rows="10"></textarea>
            </div>
          </div>
          <div class="d-flex">
            <div class="mt-4 shadow border-radius-20  col-6 d-flex flex-column align-items-start p-2">
              <p class="fw-bold">  عوامل کلیدی موفقیت برای تحقق ماموریت چیست؟  </p>
              <hr>
              <textarea :class="{'is-invalid' : text_second_error}" v-model="text_third" name="" class="form-control"
                        id="" cols="30" rows="10"></textarea>
            </div>
            <div class="mt-4 shadow border-radius-20 mx-2 col-6 d-flex flex-column align-items-start p-2">
              <p class="fw-bold">    بهترین شدن در این عوامل
                چه دورنمایی را رقم می زند؟</p>
              <hr>
              <textarea :class="{'is-invalid' : fourth_text_error}" v-model="fourth_text" name="" class="form-control"
                        id="" cols="30" rows="10"></textarea>
            </div>
          </div>
          <div class="d-flex mb-4">
            <div class="mt-4 shadow  border-radius-20 col-6 d-flex flex-column align-items-start p-2">
              <p class="fw-bold">  اکنون تحقق ماموریت به چه معنا است؟ </p>
              <hr>
              <br>
              <textarea :class="{'is-invalid' : fifth_text_error}" v-model="fifth_text" name="" class="form-control" id=""
                        cols="30" rows="10"></textarea>
            </div>
            <div class="mt-4 shadow  border-radius-20 col-6 mx-2 d-flex flex-column align-items-start p-2">
              <p class="fw-bold">    به چه هدفی برسیم می گوییم ماموریت
                ما در این برهه از زمان محقق شده است؟</p>
              <hr>
              <textarea :class="{'is-invalid' : sixth_text_error}" v-model="sixth_text" name="" class="form-control" id=""
                        cols="30" rows="10"></textarea>
            </div>
          </div>

        </div>
        <hr class="mt-2 mb-2">
        <center>
          <p @click.prevent="save" class="btn btn-submit-1 btn-primary" style="width: 15vw;">ذخیره و مرحله بعدی</p>
        </center>


      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";
import {useToast} from "vue-toastification";

const toast = useToast();

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data() {
    return {
      text_first: '',
      text_second: '',
      text_third: '',
      fourth_text: '',
      fifth_text: '',
      sixth_text: '',
      text_first_error: false,
      text_second_error: false,
      text_third_error: false,
      fourth_text_error: false,
      fifth_text_error: false,
      sixth_text_error: false,
    }
  },
  methods: {
    checkIsMother() {
      if (this.is_mother) {
        router.push('/mother_items')
        return
      }
    },
    save() {
      this.text_first_error = false
      this.text_second_error = false
      this.text_third_error = false
      this.fourth_text_error = false
      this.fifth_text_error = false
      this.sixth_text_error = false
      if (!this.text_first) {
        this.text_first_error = true
        toast.error(' چه چالش های اساسی پیش روی سازمان قرار دارد؟  اجباری است!')
        return;
      } else if (!this.text_second) {
        this.text_second_error = true
        toast.error(' اگر این چالش ها را حل کنیم آینده به چه صورتی است؟  اجباری است!')
        return;
      } else if (!this.text_third) {
        this.text_third_error = true
        toast.error(' عوامل کلیدی موفقیت برای تحقق ماموریت چیست؟   اجباری است!')
        return;
      }else if (!this.fourth_text) {
        this.fourth_text_error = true
        toast.error(' بهترین شدن در این عوامل چه دورنمایی را رقم می زند؟   اجباری است!')
        return;
      }else if (!this.fifth_text) {
        this.fifth_text_error = true
        toast.error(' اکنون تحقق ماموریت به چه معنا است؟   اجباری است!')
        return;
      }else if (!this.sixth_text) {
        this.sixth_text_error = true
        toast.error(' به چه هدفی برسیم می گوییم ماموریت ما در این برهه از زمان محقق شده است؟  اجباری است!')
        return;
      }
      fetch(`${this.base_url}/VisionQuestion`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({
          'first_text': this.text_first,
          'second_text': this.text_second,
          'third_text': this.text_third,
          'fourth_text': this.fourth_text,
          'fifth_text': this.fifth_text,
          'sixth_text': this.sixth_text,


        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response['error']) {
            }
            if (response.message){
              toast.success(response.message)
              router.push('/Vision_working_group_Gary_Hamel_questionnaire/ByType')

            }


          }).catch((err) => {
      })
    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var url = new URL(`${this.base_url}/VisionQuestion`);


      var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(url, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.data) {
              this.text_first = response.data.first_text
              this.text_second = response.data.second_text
              this.text_third = response.data.third_text
              this.fourth_text = response.data.fourth_text
              this.fifth_text = response.data.fifth_text
              this.sixth_text = response.data.sixth_text
            }
          })
          .catch(error => console.error('Error:', error));

    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a {
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3 {
  font-size: 1.3vw !important;
}

small {
  font-size: 1vw !important;
}

textarea {
  height: 6vw;
  resize: none;
}
</style>